





























import PouchDB from "pouchdb";
import {
  genPostReq
} from "@/services/checklist.service";
 
import { EventBus } from '@/event-bus.js';

import  { localPouchDb } from "@/inspect-db";




export default  {
  data () {
    return {
      initLoaded: false,
      local_db: null,
      projectId: "", 
    }
  },
  computed: {
    inspection_list() {
      let l = []
      if (this.$store.state.insp_inspections) {
        this.$store.state.insp_inspections.map(d => {
          console.log(d.doc)
          l.push({id: d.doc._id, name: d.doc.name.de, machine: d.doc.machine.name})
        });
        
        /*
        for (var i=0 ; i<this.inspections.length ; i++) {
          console.log(this.inspections[i].doc)
          l.push(this.inspections[i].doc)
        }
        */
      }
  console.log(l)
      return l
    }
  },
  components: {
  
  },
  methods: {
    replicateComplete(data) {

      if (data.name == this.projectId) {
        this.local_db.getAllInsection().then((d) => {
          if (d.rows) {
            this.$store.state.insp_inspections = d.rows
            this.initLoaded = true
          }
        })
      }
    },
    openInspection(item) {
      this.$router.push({ name: 'project-detail', params: { uid: item.id } })
    },    
  },
  mounted() {

    this.projectId = 'project-19911331'

    this.local_db = localPouchDb(this.projectId)
    this.local_db.replicate()

    EventBus.$on('replicate:complete', this.replicateComplete);

    this.$store.state.headerTitle = "Projekt "+this.projectId

    var ref = this; 

/*

      db.changes({
          since: 'now',
          live: true,
          timeout: 60000,
          //batch_size: 1,
          //batches_limit: 1,
          include_docs: true,
          attachments: true
        })
        .on('change', function(change) {
          //console.log('%c  startMonitoringChanges (handleChange): '+self.fullName, 'background: #222; color: #bada55');
         console.log("change", change)
        })
        .on('complete', function(info) {
          console.log('Monitoring changes was canceled',info);
          //self.changesHandle = null;
        })
        .on('error', function(err) {
          console.warn("Can't track changes", err);
        });
    */


/*
var dbPrefix = 'inspection/';

var idPrefix = dbPrefix

db.allDocs({
  include_docs: true,
  attachments: false,
    startkey: idPrefix,
    endkey: idPrefix + '\uffff'
}).then(function (result) {

  console.log("inspection", result)
  // handle result
}).catch(function (err) {
  console.log(err);
});
*/


/*
    var sync = PouchDB.sync('inspect-project-19911331', '', {
      live: true,
      retry: true
    }).on('change', function (info) {
      console.log("change", info)
      // handle change
    }).on('paused', function (err) {
      // replication paused (e.g. replication up to date, user went offline)
    }).on('active', function () {
      // replicate resumed (e.g. new changes replicating, user went back online)
    }).on('denied', function (err) {
      // a document failed to replicate (e.g. due to permissions)
    }).on('complete', function (info) {
      console.log("complete")
      // handle complete
    }).on('error', function (err) {
      // handle error
    });
*/



  },
   created () {
     
  },
  destroyed() {
    EventBus.$off('replicate:complete', this.replicateComplete);
  }
}

